declare namespace $ {

	export class $bog_GPTHub_button extends $mol_button_major {
	}
	
}

//# sourceMappingURL=button.view.tree.d.ts.map